import React, { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { HospitalServices } from "../services/HospitalServices";

export default function HospitalSelect({ onChange, hospitalIds, isMulti }) {
  const [selectedOptions, setSelectedOptions] = useState(hospitalIds || []);

  const loadHospitalOptions = async (searchKey, loadedOptions, { page }) => {
    try {
      const limit = 10;
      const res = await HospitalServices.gethospitals(
        searchKey || "",
        page,
        limit
      );
      const hospitals = res?.data?.list || [];
      const hasMore = res?.data?.hasMore;
      const options = hospitals.map((hospital) => ({
        value: hospital.id,
        label: hospital.name,
      }));

      return {
        options,
        hasMore,
        additional: {
          page: page + 1,
        },
      };
    } catch (err) {
      console.error("Error fetching hospitals:", err);
      return {
        options: [],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
  };

  return (
    <AsyncPaginate
      isClearable
      isMulti={isMulti}
      debounceTimeout={300}
      additional={{ page: 1 }}
      loadOptions={loadHospitalOptions}
      value={selectedOptions}
      onChange={(options) => {
        setSelectedOptions(options || []);
        onChange(options || []);
      }}
      placeholder="FILTER HOSPITAL WISE"
    />
  );
}
